<template>
    <authenticated-layout>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <div>
                <v-card class="pa-6 mx-auto" max-width="600">
                    <v-card-text>
                    <h1 class="py-2 mb-6 text-xl border-b">
                        {{ $t("pricingVariablesPanel.Pricing variables panel") }}
                    </h1>

                    <form @submit.prevent="update">
                        <div v-for="(item, index) in priceFactorsForm" :key="index"  class="d-flex items-top">
                            <v-text-field
                                v-model="item.price"
                                :label="$t(`pricingVariablesPanel.${item.name}`)"
                                variant="outlined"
                                density="compact"
                                type="input"
                            ></v-text-field>
                            <div>
                            <v-checkbox
                                label="PDF"
                                v-model="item.is_visible_in_pdf"
                            />
                            </div>
                        </div>


                        <v-btn
                            color="secondary"
                            variant="flat"
                            size="small"
                            type="submit"
                        >
                            {{ $t("pricingVariablesPanel.Update") }}
                        </v-btn>
                    </form>
                    </v-card-text>
                </v-card>
            </div>
            <div>
                <v-card class="pa-6 mx-auto" max-width="600">
                    <h1 class="py-2 mb-6 text-xl border-b">Extra Costs <v-btn
                        v-model="showAddExtraCostModal"
                        class="ml-1"
                        color="blue"
                        variant="flat"
                        size="small"
                        @click="showAddExtraCostModal = true"
                    ><v-icon size="large" icon="mdi-playlist-plus"></v-icon></v-btn></h1>

                    <form @submit.prevent="updateExtraCosts">
                        <div v-for="(item, index) in extraCostsForm" :key="index" class="d-flex items-top">
                            <v-text-field
                                v-model="item.price"
                                :label="item.name"
                                variant="outlined"
                                density="compact"
                                type="input"
                            />
                            <v-btn
                                class="mt-2 ml-1"
                                color="red"
                                variant="flat"
                                type="button"
                                size="small"
                                @click="onDeleteExtraCost(item.id, item.name)"
                            ><v-icon size="large" icon="mdi-delete-forever"></v-icon></v-btn>
                        </div>


                        <v-btn
                            color="secondary"
                            variant="flat"
                            size="small"
                            type="submit"
                        >
                            {{ $t("pricingVariablesPanel.Update") }}
                        </v-btn>
                    </form>

                    <v-dialog
                        v-model="showAddExtraCostModal"
                        max-width="400"
                        persistent
                        scrollable
                    >
                        <v-card>
                            <v-card-title class="text-subtitle-1">
                                Add a new extra cost
                            </v-card-title>

                            <v-divider/>

                            <v-card-text style="max-height: 600px">
                                <v-text-field
                                    v-model="addExtraCostForm.name"
                                    label="Name"
                                    variant="outlined"
                                    density="compact"
                                    type="input"
                                />

                                <v-text-field
                                    v-model="addExtraCostForm.price"
                                    label="Price"
                                    variant="outlined"
                                    density="compact"
                                    type="number"
                                />
                            </v-card-text>

                            <v-divider/>

                            <v-card-actions>
                                <v-spacer/>

                                <v-btn
                                    variant="flat"
                                    size="small"
                                    @click="onAddExtraCostModalCancel()"
                                >
                                    Cancel
                                </v-btn>

                                <v-btn
                                    color="secondary"
                                    variant="flat"
                                    size="small"
                                    @click="onAddExtraCostModalSave()"
                                >
                                    Add
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
            </div>
        </div>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";
import {th} from "vuetify/locale";

export default {
    props: {
        priceFactors: {
            type: Array,
            required: true,
        },
        extraCosts: {
            type: Array,
            required: true,
        },
        message: {
            type: String,
        },
    },
    components: {
        AuthenticatedLayout,
    },
    data: () => ({
        priceFactorsForm: [],
        extraCostsForm: [],
        addExtraCostForm: {
            name: null,
            price: 0,
        },
        showAddExtraCostModal: false,
    }),
    mounted() {
        this.priceFactorsForm = this.priceFactors.map((o) => ({
            id: o.id,
            name: o.name,
            price: parseFloat(o.price),
            is_visible_in_pdf: (o.is_visible_in_pdf === 1)
        }));
        this.extraCostsForm = this.extraCosts.map((o) => ({
            id: o.id,
            name: o.name,
            price: parseFloat(o.price),
        }));
    },
    methods: {
        update() {
            if (
                confirm(
                    this.$t(
                        "pricingVariablesPanel.Are you sure you want to update these prices?"
                    )
                )
            ) {
                const data = this.priceFactorsForm.map((o) => ({
                    id: o.id,
                    price: parseFloat(o.price),
                }));

                this.$inertia.patch("/pricing-variables-panel", this.priceFactorsForm);
            } else {
                location.reload();
            }
        },
        updateExtraCosts() {
            if (!confirm("Are you sure you want to update Extra Costs prices?")) {
                return;
            }

            const data = this.priceFactorsForm.map((o) => ({
                id: o.id,
                price: parseFloat(o.price),
            }));

            this.$inertia.patch(this.route("pricing-variables-panel.update-extra-costs"), this.extraCostsForm);
        },
        onAddExtraCostModalFormReset() {
            this.addExtraCostForm = {
                name: null,
                price: 0,
            };
        },
        onAddExtraCostModalCancel() {
            this.showAddExtraCostModal = false;

            this.onAddExtraCostModalFormReset();
        },
        onAddExtraCostModalSave() {
            this.$inertia.post(
                this.route("pricing-variables-panel.add-new-extra-cost"),
                this.addExtraCostForm,
                {
                    preserveState: false,
                }
            );

            this.onAddExtraCostModalCancel();
        },
        onDeleteExtraCost(extraCostId, name) {
            if (!confirm('Delete Extra cost "' + name + '"?')) {
                return;
            }

            this.$inertia.post(
                this.route("pricing-variables-panel.delete-extra-cost"),
                {
                    'extra_cost_id': extraCostId
                },
                {
                    preserveState: false,
                }
            );
        },
    },
};
</script>
